export default [
    {
        component: () => import(/* webpackChunkName: 'ambulatorio-servico' */ '@/views/ambulatorio/servico/Index'),
        path: 'servico',
        redirect: 'servico/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-servico' */'@/views/ambulatorio/servico/List.vue'),
                name: 'ambulatorio-servico-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-servico' */ '@/views/ambulatorio/servico/Form.vue'),
                name: 'ambulatorio-servico-create',
                path: 'create',
            },
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-servico' */ '@/views/ambulatorio/servico/Form.vue'),
                name: 'ambulatorio-servico-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]